import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  FETCH_AUTHENTICATED_USER_REQUEST,
  FETCH_AUTHENTICATED_USER_SUCCESS,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  SET_TOKEN,
  SESSION_EXPIRED,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_ERROR,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  SOCIAL_AUTH_REQUEST,
  SOCIAL_AUTH_SUCCESS,
  SOCIAL_AUTH_ERROR,
  SET_LOGIN_ERROR,
  UPDATE_SAGA,
  UPDATE_AUTHENTICATED_USER,
  SET_CUSTOM_QUESTION_SAGA,
  SET_ACTIVE_STEP,
  SET_QUESTION_TYPE,
  ANSWER_QUESTION_SAGA,
} from './actionTypes';

export function login(username, password, setErrors) {
  return {
    type: LOGIN_REQUEST,
    username,
    password,
    meta: {
      setErrors,
    },
  };
}

export function loginSuccess() {
  return {
    type: LOGIN_SUCCESS,
  };
}

export function loginError(error) {
  return {
    type: LOGIN_ERROR,
    error,
  };
}

export function setCustomQuestionSaga() {
  return {
    type: SET_CUSTOM_QUESTION_SAGA,
  };
}

export function setActiveStep(payload) {
  return {
    type: SET_ACTIVE_STEP,
    payload,
  };
}

export function answerQuestionSaga(payload) {
  return {
    type: ANSWER_QUESTION_SAGA,
    payload,
  };
}

export function fetchAuthenticatedUser() {
  return {
    type: FETCH_AUTHENTICATED_USER_REQUEST,
  };
}

export function fetchAuthenticatedUserSuccess(user) {
  return {
    type: FETCH_AUTHENTICATED_USER_SUCCESS,
    user,
  };
}

export function setQuestionType(payload) {
  return {
    type: SET_QUESTION_TYPE,
    payload,
  };
}

export function logout() {
  return {
    type: LOGOUT_REQUEST,
  };
}

export function logoutSuccess() {
  return {
    type: LOGOUT_SUCCESS,
  };
}

export function setToken(token) {
  return {
    type: SET_TOKEN,
    token,
  };
}

export function sessionExpired() {
  return {
    type: SESSION_EXPIRED,
  };
}

export function forgotPassword(email, setErrors) {
  return {
    type: FORGOT_PASSWORD_REQUEST,
    email,
    meta: {
      setErrors,
    },
  };
}

export function forgotPasswordSuccess() {
  return {
    type: FORGOT_PASSWORD_SUCCESS,
  };
}

export function forgotPasswordError() {
  return {
    type: FORGOT_PASSWORD_ERROR,
  };
}

export function register(firstName, lastName, email, password, setErrors) {
  return {
    type: REGISTER_REQUEST,
    firstName,
    lastName,
    email,
    password,
    meta: {
      setErrors,
    },
  };
}

export function registerSuccess() {
  return {
    type: REGISTER_SUCCESS,
  };
}

export function registerError() {
  return {
    type: REGISTER_ERROR,
  };
}

export function resetPassword(password, passwordConfirmation, setErrors) {
  return {
    type: RESET_PASSWORD_REQUEST,
    password,
    passwordConfirmation,
    meta: {
      setErrors,
    },
  };
}

export function resetPasswordSuccess() {
  return {
    type: RESET_PASSWORD_SUCCESS,
  };
}

export function resetPasswordError() {
  return {
    type: RESET_PASSWORD_ERROR,
  };
}

export function socialAuthentication(accessToken, provider) {
  return {
    type: SOCIAL_AUTH_REQUEST,
    accessToken,
    provider,
  };
}

export function socialAuthSuccess() {
  return {
    type: SOCIAL_AUTH_SUCCESS,
  };
}

export function socialAuthError(error) {
  return {
    type: SOCIAL_AUTH_ERROR,
    error,
  };
}

export function setLoginError(error) {
  return {
    type: SET_LOGIN_ERROR,
    error,
  };
}

export function updateSaga(payload) {
  return {
    type: UPDATE_SAGA,
    payload,
  };
}

export function updateAuthenticatedUser(payload) {
  return {
    type: UPDATE_AUTHENTICATED_USER,
    payload,
  };
}
